// Copyright 2025. WebPros International GmbH. All rights reserved.

export const SET_TASKS = 'task/SET_TASKS';
export const APPEND_TASK = 'task/APPEND_TASK';
export const APPEND_TASKS = 'task/APPEND_TASKS';
export const SET_TASK = 'task/SET_TASK';
export const UPDATE_TASK = 'task/UPDATE_TASK';
